module.exports = __webpack_public_path__ + "31e0eac4ab15aa49c6817d59ad5d8420.png";